var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rentabilidade-chart" },
    [
      _c("line-chart", {
        attrs: {
          "chart-data": _vm.formattedChartData,
          options: _vm.chartOptions
        }
      }),
      _c("ChartjsLegend", {
        staticClass: "rentabilidade-chart__legend",
        attrs: {
          datasets: _vm.formattedChartData.datasets,
          "on-toggle": _vm.toggleDatasetVisibility
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }